import React, { useEffect, useState } from "react";

import "./userInfo.css";

import UserFace from "../../../../assets/img/avatar-face.jpg";
import FavFlag from "../../../../assets/img/qatar.png";
import teamImage from "../../../../utilities/constants.json";

import ShareAlt from "../../../../assets/img/share-alt.png";

const UserInfo = (prop) => {
  const [imageUrl, setImageUrl] = useState(teamImage.team_image);
  // useEffect(()=>{
  //   if (!prop.userProfile.name)
  //   {
  //     window.location.reload()
  //   }
  // },[])
  return (
    <div className="userInfo">
      <div className="userInfo-wrapper">
        <div className="userInfo-part1">
          <div className="user-img">
            <img
              src={
                prop.userProfile.image
                  ? prop.proImage + prop.userProfile.image
                  : "/static/media/avatar-face.43ebe3233b34365dc7a5.jpg"
              }
              alt=""
              onError={(e) =>
                (e.target.onerror = null)((e.target.src = UserFace))
              }
            />
          </div>
        </div>
        <div className="userInfo-part2">
          <h6>{prop.userProfile.name}</h6>
          <h5>
            {prop.otherData.score_profile
              ? prop.otherData.score_profile.score
              : 0}{" "}
            Pts
          </h5>
          <div className="user-fav-team">
            <div className="flag-img">
              {prop.userProfile.team ? (
                <img src={imageUrl + prop.userProfile.team.team_flag} alt="" />
              ) : (
                ""
              )}
            </div>
            {prop.userProfile.team ? (
              <p>{prop.userProfile.team.team_name}</p>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      {/*<div className="share-user-info-wrapper">*/}
      {/*  <div className="share-info-icon">*/}
      {/*    <img src={ShareAlt} alt="" />*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default UserInfo;
